import React from 'react';
import { Container, Row, Col, ProgressBar } from 'react-bootstrap';
import { BsStarFill } from 'react-icons/bs';

const ratingStats = [
  { stars: '5 stars', percent: 72.25 },
  { stars: '4 stars', percent: 20.12 },
  { stars: '3 stars', percent: 1.17 },
  { stars: '2 stars', percent: 0.0 },
  { stars: '1 star', percent: 0.0 },
];

const testimonials = [
  {
    name: 'Abhay Chauhan',
    image: '/images/students/abhay.jpg',
    rating: 5,
    title: 'Structured Learning with an Exceptional Teacher',
    text: 'The course was incredibly well-structured. Every concept built on the previous one, and the teacher, Mr. Sharma, made even complex topics feel easy to grasp. He always took the time to answer questions clearly.',
  },
  {
    name: 'Gauri Bhandari',
    image: '/images/students/gauri.jpg',
    rating: 5,
    title: 'Practical and Engaging Content Delivery',
    text: 'Fantastic content with a very practical approach! The instructor kept sessions interactive and relatable. Assignments were challenging but helpful, and the pacing was just right.',
  },
  {
    name: 'Krishna Vamsy',
    image: '/images/students/krishna.jpg',
    rating: 5,
    title: 'Perfect for Beginners with Strong Guidance',
    text: 'A great starting point for beginners! The course was organized step-by-step, with helpful exercises and live examples. Kudos to the teacher for being so patient and thorough in his explanations.',
  },
];

const TestimonialsSection = () => {
  return (
    <Container className="my-5">
      <span className='text-center'><h3 className="fw-bold text-grey">Testimonials</h3></span>
      <Row className=''>
        {/* Rating Summary */}
        <Col md={3} className="mb-4">
          <div className="d-flex align-items-center mb-2">
            <BsStarFill color="#F5A623" />
            <h4 className="ms-2 mb-0 fw-bold">4.3</h4>
            <small className="text-muted ms-2">(3204 ratings)</small>
          </div>
          {ratingStats.map((r, i) => (
            <div key={i} className="mb-2">
              <div className="d-flex justify-content-between">
                <small className="fw-bold">{r.stars}</small>
                <small>{r.percent.toFixed(2)}%</small>
              </div>
              <ProgressBar
                now={r.percent}
                variant="info"
                style={{ color: '#0A3980', height: '8px', backgroundColor: '#E3EBFA' }}
              />
            </div>
          ))}
        </Col>

        {/* Testimonials */}
        <Col md={9} className='mt-4'>
          {testimonials.map((t, i) => (
            <div key={i} className="p-3 mb-4 bg-white rounded-4 shadow-sm border">
              <div className="d-flex justify-content-between align-items-start">
                <div style={{width: "46vw"}}>
                  <h5 className="fw-bold mb-2">{t.title}</h5>
                  <p className="mb-2 text-muted">{t.text} {t.text}</p>
                </div>
                <div className="text-end">
                  <img
                    src={t.image}
                    alt={t.name}
                    className="rounded-circle"
                    style={{ width: '40px', height: '40px' }}
                  />
                  <p className="fw-semibold mb-1">{t.name}</p>
                  <div className="text-warning">
                    {Array.from({ length: t.rating }).map((_, idx) => (
                      <BsStarFill key={idx} />
                    ))}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </Col>
      </Row>
    </Container>
  );
};

export default TestimonialsSection;
